export const ADD_URL = 'ADD_URL';

export function addURL(url) {
  return { type: ADD_URL, url: url };
}